import Svg, { Path } from 'react-native-svg'

const BankIcon = ({ width = 22, height = 22, color = '#fff' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M19.254 5.942 11.54 3.371a1.783 1.783 0 0 0-1.08 0L2.746 5.942a1.714 1.714 0 0 0 .54 3.343V17a.857.857 0 1 0 0 1.715h15.428a.857.857 0 1 0 0-1.715V9.285a1.714 1.714 0 0 0 .54-3.343Zm-9.111 3.343V17H8.428V9.285h1.715Zm1.714 0h1.714V17h-1.714V9.285ZM5 9.285h1.714V17H5V9.285ZM17 17h-1.714V9.285H17V17Z"
    />
  </Svg>
)
export default BankIcon
